var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 9.16667H10.2583L10.025 8.94167C10.8417 7.99167 11.3333 6.75833 11.3333 5.41667C11.3333 2.425 8.90833 0 5.91667 0C2.925 0 0.5 2.425 0.5 5.41667C0.5 8.40833 2.925 10.8333 5.91667 10.8333C7.25833 10.8333 8.49167 10.3417 9.44167 9.525L9.66667 9.75833V10.4167L13.8333 14.575L15.075 13.3333L10.9167 9.16667ZM5.91667 9.16667C3.84167 9.16667 2.16667 7.49167 2.16667 5.41667C2.16667 3.34167 3.84167 1.66667 5.91667 1.66667C7.99167 1.66667 9.66667 3.34167 9.66667 5.41667C9.66667 7.49167 7.99167 9.16667 5.91667 9.16667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.b8c462bc.svg";
export { ForwardRef as ReactComponent };